import React, { Component } from 'react';
import 'swiper/css/swiper.min.css';
import './HorizontalImageSwiper.css';
import Swiper from 'swiper';
import HorizontalImageSwiperItem from './HorizontalImageSwiperItem';
import { withHistory } from 'on_web/helpers/withHistory';

/**
 * Component representing horizontal swiper control for images.
 */
class HorizontalImageSwiper extends Component {
  componentDidMount() {
    let swiper = new Swiper('#' + this.props.uid, {
      slidesPerView: 'auto',
      freeMode: true,
      allowTouchMove: true,
    });

    // if selected slide is defined, slide to it
    if (this.props.selectedSlideIx) {
      if (this.props.firstStep) {
        swiper.slideTo(this.props.selectedSlideIx - 1);
      } else {
        swiper.slideTo(this.props.selectedSlideIx - 1, 0, false);
      }
    }
  }

  render() {
    return (
      <div className="swiper-container" id={this.props.uid}>
        <div className="swiper-wrapper">
          {this.props.items &&
            this.props.items.map((item, index) => (
              <div
                className={'swiper-slide ' + this.props.slideClassName}
                key={index}
              >
                <a
                  style={{
                    textDecoration: 'none',
                  }}
                  key={index}
                  onClick={e => {
                    e.preventDefault();
                    if (item.link === '#') {
                      return;
                    }

                    this.props.history.push({
                      pathname: item.link,
                      state: { startFromFirst: true },
                    });
                  }}
                >
                  <HorizontalImageSwiperItem
                    icon={
                      this.props.selectedSlideIx >= index
                        ? item.selectedImg
                        : item.unselectedImg
                    }
                    text={this.props.selectedSlideIx === index ? item.text : ''}
                    textColor={item.textColor}
                    leftDots={index === 0 ? false : true}
                    rightDots={
                      index === this.props.items.length - 1 ? false : true
                    }
                  />
                </a>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default withHistory(HorizontalImageSwiper);
